// Config panel for the "reject_call" action block
import React from 'react';
import {
  Box,
  TextField,
  Typography,
  MenuItem,
  Alert
} from '@mui/material';

const REASONS = [
  { value: 'congestion', label: 'Congestion', description: 'Caller hears congestion tone (fast busy)' },
  { value: 'busy', label: 'Busy', description: 'Caller hears busy tone' },
  { value: 'forbidden', label: 'Forbidden', description: 'Call is silently dropped' },
];

const RejectCallConfig = ({ config, onChange, onSummaryChange }) => {
  const handleChange = (field, value) => {
    const updated = { ...config, [field]: value };
    onChange(updated);
    const reason = REASONS.find(r => r.value === updated.reason) || REASONS[0];
    onSummaryChange(`Reject (${reason.label})`);
  };

  const selectedReason = REASONS.find(r => r.value === config.reason) || REASONS[0];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Reject the incoming call. The caller will hear a tone or the call will be dropped,
        depending on the reason selected.
      </Typography>

      <TextField
        size="small"
        select
        label="Rejection Reason"
        value={config.reason || 'congestion'}
        onChange={(e) => handleChange('reason', e.target.value)}
      >
        {REASONS.map((r) => (
          <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>
        ))}
      </TextField>

      <Alert severity="warning" variant="outlined" sx={{ py: 0.5, '& .MuiAlert-message': { fontSize: '0.7rem' } }}>
        {selectedReason.description}
      </Alert>
    </Box>
  );
};

export default RejectCallConfig;
